import React, { useState } from 'react';
import PageContainer from '../components/PageContainer';
import { FiMapPin, FiStar, FiBell, FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const tourDates = [
  { id: 1, date: "OCT 24", day: "Thu", venue: "Madison Square Garden", city: "New York, NY", status: "Tickets Available", isVip: true },
  { id: 2, date: "OCT 26", day: "Sat", venue: "TD Garden", city: "Boston, MA", status: "Tickets Available", isVip: false },
  { id: 3, date: "OCT 28", day: "Mon", venue: "Wells Fargo Center", city: "Philadelphia, PA", status: "Low Tickets", isVip: true },
  { id: 4, date: "NOV 02", day: "Sat", venue: "United Center", city: "Chicago, IL", status: "Sold Out", isVip: false },
  { id: 5, date: "NOV 08", day: "Fri", venue: "Red Rocks Amphitheatre", city: "Morrison, CO", status: "Tickets Available", isVip: true },
  { id: 6, date: "NOV 15", day: "Fri", venue: "Crypto.com Arena", city: "Los Angeles, CA", status: "Presale Active", isVip: true },
];

export default function Events() {
  const [reminders, setReminders] = useState({});

  const toggleReminder = (id) => {
    setReminders(prev => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <PageContainer title="Tour & Events">
      <div className="bg-sun-yellow/10 border border-sun-yellow/30 rounded-lg p-4 mb-8 flex items-start gap-4">
        <SafeIcon icon={FiStar} className="text-sun-yellow w-6 h-6 flex-shrink-0 mt-1" />
        <div>
          <h4 className="text-sun-yellow font-bold text-lg">Club Members Get First Access!</h4>
          <p className="subtitle-typewriter text-sm">Don't miss the beat. Set reminders for your city.</p>
        </div>
      </div>

      <div className="flex flex-col gap-4">
        {tourDates.map((tour) => (
          <div key={tour.id} className="flex flex-col md:flex-row items-center justify-between bg-grunge-gray border-l-4 border-sun-yellow rounded-r-lg p-6 hover:bg-gray-800 transition-colors">
            
            <div className="flex items-center gap-6 w-full md:w-auto mb-4 md:mb-0">
              <div className="text-center min-w-[80px]">
                <p className="font-typewriter text-sun-yellow text-xs uppercase">{tour.day}</p>
                <p className="text-3xl font-display text-white">{tour.date}</p>
              </div>
              
              <div>
                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                  {tour.venue}
                  {tour.isVip && <span className="bg-sun-yellow text-black text-[10px] uppercase px-2 py-0.5 rounded-full font-bold ml-2">VIP Avail</span>}
                </h3>
                <p className="font-typewriter text-gray-400 flex items-center gap-1 mt-1 text-sm">
                  <SafeIcon icon={FiMapPin} className="w-4 h-4" /> {tour.city}
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto items-center">
              <button 
                onClick={() => toggleReminder(tour.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-full font-typewriter text-sm transition-all ${
                  reminders[tour.id] 
                    ? 'bg-green-500/20 text-green-400 border border-green-500/50' 
                    : 'bg-white/5 text-gray-400 border border-white/10 hover:bg-white/10'
                }`}
              >
                <SafeIcon icon={reminders[tour.id] ? FiCheckCircle : FiBell} />
                {reminders[tour.id] ? 'Reminder Set' : 'Set Reminder'}
              </button>

              <div className="flex gap-2 w-full sm:w-auto">
                {tour.status === "Sold Out" ? (
                  <button disabled className="bg-gray-700 text-gray-500 font-bold py-2 px-6 rounded uppercase cursor-not-allowed text-xs">
                    Sold Out
                  </button>
                ) : (
                  <button className="bg-sun-yellow text-black font-bold py-2 px-6 rounded hover:bg-white transition-colors uppercase text-xs">
                    Tickets
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </PageContainer>
  );
}